import { render } from "./Resultados.vue?vue&type=template&id=5dec261e&scoped=true"
import script from "./Resultados.vue?vue&type=script&lang=js"
export * from "./Resultados.vue?vue&type=script&lang=js"

import "./Resultados.vue?vue&type=style&index=0&id=5dec261e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dec261e"]])

export default __exports__